/* eslint-disable react-hooks/exhaustive-deps */
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { getTeacherDashboardKPIs } from "../../../services/firebaseService";
import { TeacherDashboardKPIs } from "./dashboard.type";


export const DashboardApi = createApi({
    reducerPath: "dashboardApi",
    tagTypes: ["dashboard"],
    baseQuery: fakeBaseQuery(),
    endpoints: (builder) => ({
        getDashboardKpisTeacher: builder.query<TeacherDashboardKPIs, 'week' | 'month' | 'year'>({
            async queryFn(period) {
                try {
                    const response = await getTeacherDashboardKPIs(period ?? 'week');
                    return { data: response };
                } catch (error) {
                    return { error };
                }
            },
            providesTags: ["dashboard"],
        })
    }),
});

export const {
    useLazyGetDashboardKpisTeacherQuery
} = DashboardApi;
